/**
 * Serialize ShapeManager bag for postMessage (drop widget entity ids).
 */
export default function serializeTvChartBridgeShapes(shapes) {
  const source = shapes || {};
  const result = {};

  Object.keys(source).forEach(key => {
    const shape = source[key];

    if (!shape) {
      return;
    }

    result[key] = {
      intervalTypeId: shape.intervalTypeId,
      points: shape.points,
      options: shape.options
    };
  });

  return result;
}
